import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@maui/elements'
import { UpgradeButton } from '@maui/freemium'

export const Freemium = ({ ...props }) => {
  const onUpgradeClick = () => {
    window.location.href = '/upgrade'
  }

  return (
    <Box
      { ...props }
      alignItems='center'
      backgroundPosition='center center'
      backgroundImage={'url(/icons/pattern.svg)'}
      width='100%'
      height='130px'
      display='flex'
      justifyContent='center'
      backgroundRepeat='repeat'
    >
      <UpgradeButton onClick={onUpgradeClick}>
        Upgrade To View
      </UpgradeButton>
    </Box>
  )
}

Freemium.propTypes = {
  children: PropTypes.node,
}

export default Freemium
